<template>
  <div>文章管理</div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods:{
    }, 
    mounted() {
      console.log(133333);
    }
};
</script>


<style>

</style>